import { Badge, Card } from "react-bootstrap"
import { fechaATexto } from "../../lib/helpers/helpers"
import { tipos_campos_personalizados } from "./data"

const BoxList = (props) => {
    const proveedor = props.proveedor ? props.proveedor : false
    const seleccionado = props.seleccionado ? props.seleccionado : false

    if(!proveedor) return false

    const onClickProveedor = (id) => {
        if(props.onClickProveedor) return props.onClickProveedor(id)
        return false
    }
    let objeto = {}
    for( const e of tipos_campos_personalizados ){
        objeto[e.value] = e.label
    }

    return <Card bg={ seleccionado === true ? 'primary' : 'white' } className={`p-3 ${seleccionado === true ? 'text-white' : 'text-dark'}`} onClick={() => onClickProveedor(proveedor._id)}>
    <h6 style={{ fontSize: 13 }} className="mb-1">{proveedor.nombre}</h6>
    <Badge variant="secondary" style={{ fontSize: 13 }} className="mb-1">{ objeto[ proveedor.module ] ? objeto[ proveedor.module ] : "Sin información" }</Badge>
    <h6 style={{ fontSize:13, fontWeight:'lighter' }} className="mb-0">{ fechaATexto(proveedor.createdAt)}</h6>
</Card>
}

export default BoxList